import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import ClaimNotificationsCard from './ClaimNotificationsCard/ClaimNotificationsCard';

import { useStyles } from '../assets/styles';

const UserClaimsNotifications = ({ showOpenInFullScreen, onlyDismissed }) => {
  const { classes } = useStyles();

  const actionComponent = showOpenInFullScreen ? (
    <Link to="/notifications" className={classes.primaryLink}>
      See all notifications
    </Link>
  ) : null;

  const goBackFromDismissed = (
    <div className="mb-16">
      <Link to="/" className={classes.primaryLink}>
        Back to active notifications
      </Link>
    </div>
  );

  const goToDismissedComponent = (
    <div className="mb-16">
      <Link
        to="/dismissed_notifications"
        className="cursor-pointer font-bold text-teal-700 no-underline hover:underline"
      >
        See dismissed notifications
      </Link>
    </div>
  );

  return (
    <ClaimNotificationsCard
      userContext
      showExposure
      actionComponent={actionComponent}
      onlyDismissed={onlyDismissed}
      dismissedNavigationComponent={onlyDismissed ? goBackFromDismissed : goToDismissedComponent}
    />
  );
};

UserClaimsNotifications.propTypes = {
  showOpenInFullScreen: PropTypes.bool,
  onlyDismissed: PropTypes.bool,
};

export default UserClaimsNotifications;
